import React, { Component } from 'react';
import PropsRoute from '../../../hoc/PropsRoute/PropsRoute';

import Auxi from '../../../hoc/Auxi/Auxi';
import HandlingUserDataModal from '../../../components/Modals/HandlingUserData/HandlingUserData';
import IndexPage from '../../IndexPage/IndexPage';
import paths from '../../../constants/paths';

export default class HandlingUserData extends Component {
  goBack = () => {
    if (this.props.history.action === 'PUSH') {
      this.props.history.goBack();
    } else {
      this.props.history.push(paths.INDEX);
    }
  }

  render () {
    return (
      <Auxi>
        {this.props.isLandscape && !this.props.noBack ? <PropsRoute isLandscape={this.props.isLandscape} component={IndexPage} /> : null}
        <HandlingUserDataModal goBack={this.goBack} isLandscape={this.props.isLandscape} />
      </Auxi>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Modals/HandlingUserData/HandlingUserData.js